import { FC } from 'react';

import { SnackbarOrigin } from '@mui/material/Snackbar';
import { colorsSelector } from '@redux/colorPalette/selectors';
import { useSelector } from 'react-redux';

import { Container, Content } from './FlashMessage.style';
import TransitionDown from './FlashMessageTransition';

const DURATION = 5000;

interface FlashMessageProps {
  message: string;
  isShown: boolean;
  onClose: () => void;
}

const FlashMessage: FC<FlashMessageProps> = ({ message, isShown, onClose }) => {
  const POSITION: SnackbarOrigin = { vertical: 'top', horizontal: 'center' };
  const colors = useSelector(colorsSelector);
  return (
    <Container
      anchorOrigin={POSITION}
      open={isShown}
      autoHideDuration={DURATION}
      TransitionComponent={TransitionDown}
      {...{ onClose, message }}
    >
      <Content {...{ message }} colors={colors} />
    </Container>
  );
};

export default FlashMessage;
